import React from 'react';
import { Switch, Route } from 'react-router-dom';
import EstadisticasContainer from './PageContainer';

function Estadisticas() {
  return (
    <>
      <Switch>
        <Route path='/estadisticas'>
          <EstadisticasContainer />
        </Route>
      </Switch>
    </>
  );
}

export { Estadisticas };
